import {optimizedNumberToLetterPair} from "@/utils/commonUtils";

export default (self,info)=>{
  let columnDefs = []
  columnDefs.push(
    {
      headerName: '',
      width: 30,
      field: 'rowIndex',
      hidden: true,
      suppressMovable: true,
      cellStyle: {
        textAlign: 'center',
        padding: '5px 0',
        color: '#595959',
        backgroundColor: '#f0f0f0',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontWeight: '500',
        boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)'
      }
    }
  )
  columnDefs.push(
    {
      headerName: '题目分类',
      field: 'categoryName',
      width: 20,
      cellStyle: {
        textAlign: 'center',
      },
      style: {
        alignment: { vertical: 'bottom', horizontal: 'left' },
      },
    },
    {
      headerName: '题目编码',
      field: 'number',
      width: 20,
      cellStyle: {
        textAlign: 'center',
      },
      style: {
        alignment: { vertical: 'bottom', horizontal: 'left' },
      },
    },
    {
      headerName: '题目类型',
      field: 'type',
      width: 20,
      cellStyle: {
        textAlign: 'center',
      },
      style: {
        alignment: { vertical: 'bottom', horizontal: 'left' },
      },
    },
    {
      headerName: '题目内容',
      field: 'title',
      width: 20,
      cellStyle: {
        textAlign: 'center',
      },
      style: {
        alignment: { vertical: 'bottom', horizontal: 'left' },
      },
    },
    {
      headerName: '题目图片',
      field: 'img',
      width: 20,
      cellStyle: {
        textAlign: 'center',
      },
      style: {
        alignment: { vertical: 'bottom', horizontal: 'left' },
      },
    },
    {
      headerName: '选项',
      field: 'optionContents',
      width: 20,
      cellStyle: {
        textAlign: 'center',
      },
      style: {
        alignment: { vertical: 'bottom', horizontal: 'left' },
      },
    },
    {
      headerName: '答案',
      field: 'correctContent',
      width: 20,
      cellStyle: {
        textAlign: 'center',
      },
      style: {
        alignment: { vertical: 'bottom', horizontal: 'left' },
      },
    },
    {
      headerName: '试卷总份数',
      field: 'examTotalNumber',
      width: 20,
      cellStyle: {
        textAlign: 'center',
      },
      style: {
        alignment: { vertical: 'bottom', horizontal: 'left' },
      },
    },
    {
      headerName: '出题率',
      field: 'problemRate',
      width: 20,
      cellStyle: {
        textAlign: 'center',
      },
      style: {
        alignment: { vertical: 'bottom', horizontal: 'left' },
      },
    },
    {
      headerName: '答对率',
      field: 'correctRate',
      width: 20,
      cellStyle: {
        textAlign: 'center',
      },
      style: {
        alignment: { vertical: 'bottom', horizontal: 'left' },
      }
    }
  )
  let optionCountInfos = []
  if(info && info.length) {
    // info.forEach(e => {
    //   if (e['question'] && e['question'].options) {
    //     optionCountInfos = e['question'].options
    //   }
    // })

    const optionCount = info?.map(e => e?.['question']?.options?.length).reduce((acc, cur) => Math.max(acc, cur), 0);
    for(let i = 0; i < optionCount; i++) {
      optionCountInfos.push({opt: optimizedNumberToLetterPair(i + 1)})
    }
  }
  if (optionCountInfos && optionCountInfos.length) {
    optionCountInfos.forEach(e => {
      columnDefs.push({
        headerName: e['opt'],
        children: [
          {
            headerName: '选项内容',
            field: e['opt']+'_'+'content',
            width: 20,
            cellStyle: {
              textAlign: 'center',
            },
            style: {
              alignment: { vertical: 'bottom', horizontal: 'left' },
            },
          },
          {
            headerName: '选择人数',
            field: e['opt']+'_'+'optNumber',
            width: 20,
            cellStyle: {
              textAlign: 'center',
            },
            style: {
              alignment: { vertical: 'bottom', horizontal: 'left' },
            },
          },
          {
            headerName: '选择率',
            field: e['opt']+'_'+'optRate',
            width: 20,
            cellStyle: {
              textAlign: 'center',
            },
            style: {
              alignment: { vertical: 'bottom', horizontal: 'left' },
            },
          },
        ]
      })
    })
  }
  return columnDefs
}
